export default function(url, queryString) {
  const hasParams = queryString.length > 0;
  const loadParam = "_load=1";

  if(url.includes("?")) {
    url += `&${loadParam}`;
  } else {
    url += `?${loadParam}`;
  }

  if (hasParams) {
    url += `&${queryString}`;
  }

  return url;
}
